/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.orchestrator.scenario.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')

var witbooking_backoffice_orchestrator_globalactions_v1_global_actions_api_pb = require('../../../../../witbooking/backoffice/orchestrator/globalactions/v1/global_actions_api_pb.js')

var witbooking_backoffice_orchestrator_common_v1_orchestration_criteria_pb = require('../../../../../witbooking/backoffice/orchestrator/common/v1/orchestration_criteria_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.orchestrator = {};
proto.witbooking.backoffice.orchestrator.scenario = {};
proto.witbooking.backoffice.orchestrator.scenario.v1 = require('./scenario_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse>}
 */
const methodDescriptor_ScenarioAPI_GetScenario = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetScenario',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse>}
 */
const methodInfo_ScenarioAPI_GetScenario = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.getScenario =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_GetScenario,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.GetScenarioResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.getScenario =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_GetScenario);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse>}
 */
const methodDescriptor_ScenarioAPI_GetAllScenarios = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetAllScenarios',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse>}
 */
const methodInfo_ScenarioAPI_GetAllScenarios = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.getAllScenarios =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetAllScenarios',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_GetAllScenarios,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.GetAllScenariosResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.getAllScenarios =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/GetAllScenarios',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_GetAllScenarios);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse>}
 */
const methodDescriptor_ScenarioAPI_CreateScenario = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/CreateScenario',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse>}
 */
const methodInfo_ScenarioAPI_CreateScenario = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.createScenario =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/CreateScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_CreateScenario,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.CreateScenarioResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.createScenario =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/CreateScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_CreateScenario);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse>}
 */
const methodDescriptor_ScenarioAPI_UpdateScenario = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/UpdateScenario',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse>}
 */
const methodInfo_ScenarioAPI_UpdateScenario = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.updateScenario =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/UpdateScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_UpdateScenario,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.UpdateScenarioResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.updateScenario =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/UpdateScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_UpdateScenario);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse>}
 */
const methodDescriptor_ScenarioAPI_DeleteScenario = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/DeleteScenario',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse>}
 */
const methodInfo_ScenarioAPI_DeleteScenario = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.deleteScenario =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/DeleteScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_DeleteScenario,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.DeleteScenarioResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.deleteScenario =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/DeleteScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_DeleteScenario);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse>}
 */
const methodDescriptor_ScenarioAPI_ReorderScenario = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/ReorderScenario',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest,
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest,
 *   !proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse>}
 */
const methodInfo_ScenarioAPI_ReorderScenario = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIClient.prototype.reorderScenario =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/ReorderScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_ReorderScenario,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.scenario.v1.ReorderScenarioResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPIPromiseClient.prototype.reorderScenario =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.scenario.v1.ScenarioAPI/ReorderScenario',
      request,
      metadata || {},
      methodDescriptor_ScenarioAPI_ReorderScenario);
};


module.exports = proto.witbooking.backoffice.orchestrator.scenario.v1;

